<!-- TODO - this is a temporary solution, correct solution would be to create a general create account form that would read its configuration from assets/configuration/[cr|cwk]/configuration.ts -->
<div class="d-flex justify-content-center mt-3">
  <div class="card p-5 theme-tile-bg-color">
    <div class="text-center">
      <h1 class="theme-text-title-color">Create a Participant Profile</h1>
    </div>
    <form class="my-3" #profileForm="ngForm">

      <!-- FIRST NAME -->
      <div class="form-floating mb-3">
        <input type="text" class="cwk-form-control form-control" name="firstName" id="firstName" [ngClass]="{'cwk-form-control-invalid': firstName.errors && firstName.errors['pattern'], 'cwk-form-control-missing': !profile.FirstName && (firstName.dirty || firstName.touched)}" [(ngModel)]="profile.FirstName" maxlength="128" #firstName="ngModel" pattern="^[^@()&]+$" placeholder="First Name" required>
        <label for="firstName" i18n>First Name</label>
        <small class="ms-3 theme-error-color" *ngIf="!profile.FirstName && (firstName.dirty || firstName.touched)">This field is required</small>
      </div>

      <!-- LAST NAME -->
      <div class="form-floating mb-3">
        <input type="text" class="cwk-form-control form-control" name="lastName" id="lastName" [ngClass]="{'cwk-form-control-invalid': lastName.errors && lastName.errors['pattern'], 'cwk-form-control-missing': !profile.LastName && (lastName.dirty || lastName.touched)}" [(ngModel)]="profile.LastName" maxlength="128" #lastName="ngModel" pattern="^[^@()&]+$" placeholder="Last Name" required>
        <label for="lastName" i18n>Last Name</label>
        <small class="ms-3 theme-error-color" *ngIf="!profile.LastName && (lastName.dirty || lastName.touched)">This field is required</small>
      </div>

      <!-- BIRTH YEAR -->
      <div class="form-floating mb-3">
        <select #birthYear="ngModel" class="cwk-form-control form-control form-select" name="birthYear" [(ngModel)]="profile.BirthYear" [ngClass]="{'cwk-form-control-required': !profile.BirthYear && (birthYear.dirty || birthYear.touched)}" required>
          <option [ngValue]="null" disabled>Birth Year</option>
          <option *ngFor="let year of years" [ngValue]="year">{{ year }}</option>
        </select>
        <label for="birthYear" i18n>Birth Year</label>
        <small class="ms-3 theme-error-color" *ngIf="!profile.BirthYear && (birthYear.dirty || birthYear.touched)">This field is required</small>
      </div>

      <!-- BIRTH MONTH -->
      <div class="form-floating mb-3">
        <select #birthMonth="ngModel" class="cwk-form-control form-control form-select" name="birthMonth" [(ngModel)]="profile.BirthMonth" [ngClass]="{'cwk-form-control-required': (profile.BirthMonth === null) && (birthMonth.dirty || birthMonth.touched)}" required>
          <option [ngValue]="null" disabled>Birth Month</option>
          <option *ngFor="let month of months; index as i" [ngValue]="i">{{ month }}</option>
        </select>
        <label for="birthMonth" i18n>Birth Month</label>
        <small class="ms-3 theme-error-color" *ngIf="(profile.BirthMonth === null) && (birthMonth.dirty || birthMonth.touched)">This field is required</small>
      </div>

      <!-- ACCOUNT NAME -->
      <div class="form-floating mb-3">
        <input type="text" class="cwk-form-control form-control" name="account" id="account" [ngClass]="{'cwk-form-control-invalid': (account.errors && account.errors['pattern']) || (errorSaving === 'DUPLICATE') || (profile.Account && (profile.Account.length < 8) && account.touched)}" [(ngModel)]="profile.Account" (ngModelChange)="onAccountChange()" maxlength="32" minlength="8" #account="ngModel" pattern="^[A-Za-z0-9]+$" placeholder="First Name">
        <label for="account" i18n>Account Name (OPTIONAL)</label>
        <small class="ms-3 theme-error-color" *ngIf="profile.Account && account.errors && account.errors['pattern']">Invalid value - only alphanumeric characters are allowed</small>
        <small class="ms-3 theme-error-color" *ngIf="profile.Account && (profile.Account?.length < 8) && account.touched && !(account.errors && account.errors['pattern'])">Too short - at least 8 characters required</small>
        <small class="ms-3 theme-error-color" *ngIf="errorSaving === 'DUPLICATE'">The account with the same name already exists. Please choose another one.</small>
      </div>

      <!-- BUTTONS -->
      <div class="d-grid d-sm-flex gap-3 justify-sm-content-between my-4">

        <!-- CANCEL -->
        <button id="create-student-profile-form-skip" class="btn btn-warning me-5 w-100" (click)="skip()" type="button">Skip</button>

        <!-- CREATE STUDENT PROFILE BUTTON -->
        <button id="create-student-profile-form-submit" type="submit" class="btn btn-warning w-100" (click)="register()" [disabled]="isSaving || !profileForm.valid">
          <span *ngIf="isSaving; else createButton">
            <fa-icon class="me-1" [icon]="faSpinner" animation="spin"></fa-icon>Creating...
          </span>
          <ng-template #createButton>Continue</ng-template>
        </button>
      </div>
      <div class="mt-1 text-end theme-error-color" *ngIf="isInvalidSubmitted">
        <small>Required fields missing or invalid</small>
      </div>
    </form>

    <!-- ERROR CREATING ACCOUNT -->
    <cwk-error-alert *ngIf="errorSaving && !['DUPLICATE'].includes(errorSaving)" [error]="errorSaving"></cwk-error-alert>

  </div>
</div>
